type Child = Node | string | false | null | undefined;
type Props = Record<string, string | number | boolean | EventListener | undefined>;

/** Cria um elemento com atributos, eventos (`onclick`…) e filhos. Texto sempre via textContent (sem HTML injetado). */
export function h<K extends keyof HTMLElementTagNameMap>(tag: K, props: Props = {}, ...children: Child[]): HTMLElementTagNameMap[K] {
  const element = document.createElement(tag);
  for (const [key, value] of Object.entries(props)) {
    if (value === undefined || value === false) continue;
    if (key.startsWith("on") && typeof value === "function") element.addEventListener(key.slice(2), value);
    else if (key === "class") element.className = String(value);
    else if (value === true) element.setAttribute(key, "");
    else element.setAttribute(key, String(value));
  }
  for (const child of children) {
    if (child === false || child === null || child === undefined) continue;
    element.append(typeof child === "string" ? document.createTextNode(child) : child);
  }
  return element;
}

/** Troca o conteúdo de um container. */
export function mount(container: HTMLElement, ...children: Child[]): void {
  container.replaceChildren(...children.filter((c): c is Node | string => c !== false && c !== null && c !== undefined));
}
